module.exports = __webpack_public_path__ + "img/caomeixuebing.ac1697e9.jpg";